import { inject, Injectable } from "@angular/core";
import { catchError, EMPTY, map, Observable } from "rxjs";
import { toFieldStringArray } from "../../../../common/utils/object-paths";
import { ApiService } from "../../../api/packbo/api.service";
import { readItemsPages } from "../../../api/packbo/fn/items/read-items-pages";
import { PageStore } from "./page.store";

@Injectable()
export class PageService {
    private readonly store = inject(PageStore);
    private readonly apiService = inject(ApiService);

    public loadPage(slug: string): Observable<void> {
        const pageFields = toFieldStringArray({
            id: null,
            name: null,
            blocks_refs: {
                id: null,
                item: [
                    "translations_refs.*",
                    "learn_more_button_ref.page_ref.translations_refs.*",
                    "suppliers_refs.suppliers_id.*",
                    "suppliers_refs.suppliers_id.package_ref.*",
                    "suppliers_refs.suppliers_id.translations_refs.*",
                    "ads_refs.ads_id.id",
                    "ads_refs.ads_id.image.*",
                    "ads_refs.ads_id.url",
                    "partners_refs.partners_id.*",
                    "link.*",
                    "link.translations_refs.*",
                    "link.page_ref.*",
                    "link.page_ref.translations_refs.*",
                    "blocks_refs.*",
                    "blocks_refs.item.*",
                    "blocks_refs.item.blocks_refs.*",
                    "blocks_refs.item.blocks_refs.item.*",
                    "blocks_refs.item.blocks_refs.item.translations_refs.*",
                    "blocks_refs.item.categories_refs.product_categories_id.*",
                    "blocks_refs.item.categories_refs.product_categories_id.translations_refs.*",
                    "blocks_refs.item.translations_refs.*",
                    "blocks_refs.item.ads_refs.ads_id.id",
                    "blocks_refs.item.ads_refs.ads_id.image.*",
                    "blocks_refs.item.ads_refs.ads_id.url",
                    "blocks_refs.item.link.*",
                    "blocks_refs.item.privacy_policy_navigation_item_ref.*",
                    "blocks_refs.item.privacy_policy_navigation_item_ref.translations_refs.*",
                    "blocks_refs.item.privacy_policy_navigation_item_ref.page_ref.*",
                    "blocks_refs.item.privacy_policy_navigation_item_ref.page_ref.translations_refs.*",
                    "blocks_refs.item.link.page_ref.*",
                    "blocks_refs.item.link.page_ref.translations_refs.*",
                    "blocks_refs.item.link.translations_refs.*",
                    "blocks_refs.item.partners_refs.partners_id.*",
                    "blocks_refs.item.resources_refs.resources_id.*",
                    "blocks_refs.item.resources_refs.resources_id.file_ref.*",
                    "blocks_refs.item.resources_refs.resources_id.translations_refs.*",
                    "blocks_refs.item.resources_refs.resources_id.categorie_ref.*",
                    "blocks_refs.item.resources_refs.resources_id.categorie_ref.translations_refs.*",
                    "blocks_refs.item.packages_features_refs.package_features_id.*",
                    "blocks_refs.item.packages_features_refs.package_features_id.translations_refs.*",
                    "blocks_refs.item.package.*",
                    "blocks_refs.item.package.translations_refs.*",
                    "blocks_refs.item.ad_packages_features_refs.package_features_id.*",
                    "blocks_refs.item.ad_packages_features_refs.package_features_id.translations_refs.*",
                    "blocks_refs.item.ad_packages_refs.ad_packages_id.*",
                    "blocks_refs.item.ad_packages_refs.ad_packages_id.link.*",
                    "blocks_refs.item.ad_packages_refs.ad_packages_id.link.page_ref.*",
                    "blocks_refs.item.ad_packages_refs.ad_packages_id.link.page_ref.translations_refs.*",
                    "blocks_refs.item.ad_packages_refs.ad_packages_id.translations_refs.*",
                    "blocks_refs.item.navigation_item_ref.*",
                    "blocks_refs.item.navigation_item_ref.page_ref.*",
                    "blocks_refs.item.navigation_item_ref.page_ref.translations_refs.*",
                    "*"
                ],
                pages_id: null,
                sort: null,
                collection: null
            },
            translations_refs: {
                languages_code: null,
                title: null,
                slug: null,
                meta_description: null
            }
        });

        const filters = JSON.stringify({ translations_refs: { slug: { _eq: slug } } });

        return this.apiService.invoke(readItemsPages, { fields: pageFields, filter: filters }).pipe(
            map((pages) => this.store.setPage(pages.data?.[0] ?? null)),
            catchError(() => EMPTY)
        );
    }
}
